import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse, PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

type FetchAllWorkspacesPayload = {
    pageSize?: number;
    pageIndex?: number;
    sortCriteria?: string;
    sortDirection?: string;
    fromExpirationDate?: string;
    toExpirationDate?: string;
    includeTerminated?: boolean;
    billingType?: "manual" | "paypal" | "stripe";
};

export async function fetchAllWorkspaces(payload?: FetchAllWorkspacesPayload) {
    try {
        const endpoint = await RouteService.getWorkspacesRoute();
        const { data } = await HttpService.get<PaginatedResponse<API.Workspace>>(endpoint + "all", {
            headers: { "content-type": "application/json" },
            params: payload
                ? {
                      PageIndex: payload.pageIndex,
                      PageSize: payload.pageSize,
                      SortCriteria: payload.sortCriteria,
                      SortDirection: payload.sortDirection,
                      FromExpirationDate: payload.fromExpirationDate,
                      ToExpirationDate: payload.toExpirationDate,
                      IncludeTerminated: payload.includeTerminated,
                      BillingType: payload.billingType,
                  }
                : undefined,
        });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function deleteWorkspace(id: number) {
    try {
        const endpoint = await RouteService.getWorkspacesRoute();
        await HttpService.delete(endpoint + String(id));
    } catch (error) {
        throw unpackError(error);
    }
}

type GuidAvailabilityResponse = {
    available: boolean;
    message: string;
};
export async function checkGuidAvailability(guid: string): Promise<GuidAvailabilityResponse> {
    try {
        const endpoint = await RouteService.getWorkspacesRoute();
        const { data } = await HttpService.get<ApiResponse<boolean>>(endpoint + `guids/${guid}/availability`);
        return {
            available: data.model,
            message: data.message,
        };
    } catch (error) {
        throw unpackError(error);
    }
}
